import { Svg } from '@manomano-internal/tamagoshi-icons/esm/SvgOptimizer/Svg';

import { makeTamagoshiIcon } from '@/core/tamagoshiTailwind/util/makeTamagoshiComponent';

export const CategoryTimberIcon = makeTamagoshiIcon((props, ref) => (
  <Svg
    height="24"
    optimizationId="tama-category-timber"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={ref}
  >
    <path
      className="fill-brand-primary"
      d="M7.68428 4.25106C7.68428 3.98808 7.89936 3.77951 8.17056 3.77951H15.8202C16.0914 3.77951 16.3065 3.98808 16.3065 4.25106V19.5675H17.1014V3.48932C17.1014 3.21727 16.8676 2.99963 16.5964 2.99963H7.40373C7.12318 2.99963 6.89874 3.22634 6.89874 3.48932L6.89758 19.5696H7.69247L7.69363 4.25106H7.68428Z"
    />
    <path
      className="fill-brand-primary"
      d="M8.32007 4.396V19.5673H15.6705V4.396H8.32007Z"
    />
    <path
      d="M15.8295 3.77942H8.17049C7.89929 3.77942 7.6842 3.98799 7.6842 4.25097V19.5674H8.32012V4.39607H15.6705V19.5674H16.3064V4.25097C16.3158 3.99706 16.0913 3.77942 15.8295 3.77942Z"
      fill="white"
    />
    <path
      className="fill-accent-primaryActive"
      d="M17.8027 19.5677H17.1013H16.3064H15.6705H8.3201H7.68419H6.8893H6.19728C5.79516 19.5677 5.4585 19.8851 5.4585 20.284C5.4585 20.683 5.7858 21.0003 6.19728 21.0003H17.8027C18.2048 21.0003 18.5414 20.683 18.5414 20.284C18.5414 19.8851 18.2141 19.5677 17.8027 19.5677Z"
    />
    <path
      className="fill-accent-primaryActive"
      d="M15.2716 11.9283C15.2425 11.5048 14.8843 11.1776 14.4583 11.1776C14.0033 11.1776 13.6354 11.5433 13.6354 11.9956C13.6354 12.448 14.0033 12.8137 14.4583 12.8137C14.894 12.8137 15.2425 12.4769 15.2716 12.063C15.2716 12.0438 15.2716 12.0245 15.2716 12.0053C15.2716 11.986 15.2716 11.9571 15.2716 11.9283Z"
    />
  </Svg>
));

CategoryTimberIcon.displayName = 'CategoryTimberIcon';
